{
    "form_title": "New Contact Person",
    "form_sub_title": "This will be saved in the ERP system and is visible to everyone",

    "form_label__title": "Title",
    "form_label__first_name": "FirstName",
    "form_label__last_name": "Last Name",
    "form_label__email": "Email",
    "form_label__phone": "Phone",
    "form_label__mobile": "Mobile",
    "form_label__fax": "Fax",

    "form_placeholder__title": "Mr.",
    "form_placeholder__first_name": "John",
    "form_placeholder__last_name": "Doe",
    "form_placeholder__email": "j.doe@email.com",
    "form_placeholder__phone": "0123 12312341",
    "form_placeholder__mobile": "0123 12312341",
    "form_placeholder__fax": "0123 12312341"
}
